import { useMemo } from 'react';

import { PaletteColor } from '@utils/types';

import { StyledProfileName } from './styled';

const FormattedProfileName = ({
  profileName,
  textColor = 'D500',
}: {
  profileName: string;
  textColor?: PaletteColor;
}) => {
  const shortName = useMemo(() => {
    if (profileName?.length === 0) return '';

    if (profileName.length < 15) return profileName;

    const nameParts = profileName.split(' ');

    const firstLetters = [];

    for (let i = 0; i < nameParts?.length - 1; i++) {
      firstLetters.push(nameParts[i][0]);
    }

    return `${firstLetters.join('')} ${nameParts[nameParts.length - 1]}`;
  }, [profileName]);

  return (
    <StyledProfileName textColor={textColor}>{shortName}</StyledProfileName>
  );
};

export default FormattedProfileName;
